import { ItemMonitoramentoDetalhado } from './item-monitoramento-detalhado.model';

export class AtivoMonitoramentoDetalhado {

  constructor(
    public nome: string,
    public itens: ItemMonitoramentoDetalhado[]) {}

  public isSucesso(): boolean {
    return !this.isFalha();
  }

  public isFalha(): boolean {
    return this.itens.filter(item => item.isFalha()).length > 0;
  }

  public getFalhasDescricao(): string {
    return this.itens.filter(item => item.isFalha()).map(item => item.erro).join('<br/>');
  }
}

